import { Box, Divider, Stack } from '@mui/material';
import { editor } from 'monaco-editor';
import DrivebaseControl from '../../Drawers/Drivebase/DrivebaseControl';
import { ActionMappingControlList } from '../../Drawers/Controller/ActionMappingControlList';

interface DrivebaseConfigurationTabProps {
  editor?: editor.IStandaloneCodeEditor;
}

const DrivebaseConfigurationTab: React.FC<DrivebaseConfigurationTabProps> = ({ editor }) => {
  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="column" spacing={2}>
        <Box
          width="100%"
          alignSelf="center"
          textAlign="center"
          sx={{
            // Make the drivebase controller SVG responsive up to 300px, then fixed
            '& svg': { width: '100%', maxWidth: 300, height: 'auto' },
          }}
        >
          <DrivebaseControl editor={editor} />
        </Box>
        <Divider />
        <ActionMappingControlList device="drivebase" editor={editor} />
      </Stack>
    </Box>
  );
};

export default DrivebaseConfigurationTab;
